"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuardErrorPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var core_1 = require("@athena-portal/core");
var Header_1 = require("../navigator/Header");
var portal_core_1 = require("@ferry/portal-core");
var GuardErrorPage = /** @class */ (function (_super) {
    __extends(GuardErrorPage, _super);
    function GuardErrorPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.REDIRECT_AFTER_LOGIN = "REDIRECT_AFTER_LOGIN";
        _this.handleLogin = function (event) {
            event.preventDefault();
            window.sessionStorage.setItem(_this.REDIRECT_AFTER_LOGIN, "true");
            _this.applicationGuard.getLoginUrl("");
            _this.applicationGuard.logout();
        };
        return _this;
    }
    GuardErrorPage.prototype.componentDidMount = function () {
        document.title = "".concat(portal_core_1.resourcesHelper.THEME_NAME, " Car Insurance Login page");
        if (window.sessionStorage.getItem(this.REDIRECT_AFTER_LOGIN) === "true") {
            window.sessionStorage.removeItem(this.REDIRECT_AFTER_LOGIN);
            window.location.pathname = "dashboard";
        }
    };
    GuardErrorPage.prototype.render = function () {
        if (window.sessionStorage.getItem(this.REDIRECT_AFTER_LOGIN) === "true") {
            return null;
        }
        return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)(Header_1.Header, {}), (0, jsx_runtime_1.jsx)("div", { className: "journey-content error-page", children: (0, jsx_runtime_1.jsx)("div", { className: "journey-questions", children: (0, jsx_runtime_1.jsxs)("div", { className: "panel mb-3", children: [(0, jsx_runtime_1.jsx)("p", { className: "text-center text-uppercase mt-2 mb-0 error-title", children: "Session expired" }), (0, jsx_runtime_1.jsx)("img", { className: "d-block mx-auto mb-5", src: "/".concat(portal_core_1.resourcesHelper.THEME_PATH, "/img/Flourish-error.svg"), alt: "Error" }), (0, jsx_runtime_1.jsx)("h2", { className: "text-center mt-3 mb-5 error-text", children: "Your session expired due to inactivity" }), (0, jsx_runtime_1.jsxs)("a", { className: "btn btn-primary btn-next-arrow-separate btn-wide", href: "#", onClick: this.handleLogin, children: ["Log in", (0, jsx_runtime_1.jsx)("img", { className: "arrow-next", alt: "Arrow icon", src: "/img/arrow-next.png" })] })] }) }) }), (0, jsx_runtime_1.jsx)(portal_core_1.Footer, {})] }));
    };
    __decorate([
        (0, core_1.lazyInject)(core_1.TypeDefs.ApplicationGuard),
        __metadata("design:type", Object)
    ], GuardErrorPage.prototype, "applicationGuard", void 0);
    return GuardErrorPage;
}(React.Component));
exports.GuardErrorPage = GuardErrorPage;
//# sourceMappingURL=GuardErrorPage.js.map